import ResetPassword from "../../../components/resetPassword";

const resetPasswordRoute = [{
    path: "auth/reset", // or whatever path you prefer
    element: <ResetPassword />,
}]
export default resetPasswordRoute